import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { BREAKPOINTS, BREAKPOINT_SIZES } from 'tradera-utils/breakpoints';

class ViewItemImage extends Component {
    constructor(props) {
        super(props);

        this.imageContainer = React.createRef();
        this.zoomImage = React.createRef();

        this.bounds = null;

        this.state = {
            hover: false,
            zoomImageLargeEnough: true
        };
    }

    static defaultProps = {
        enableZoom: false
    };

    handleMouseHover(hoverState) {
        this.setState(prevState => ({
            ...prevState,
            hover: hoverState
        }));
    }

    handleMouseMove(e) {
        // this check is here because the mobile version does not have a zoomImageElement in the DOM.
        if (this.zoomImage.current === null) {
            return;
        }
        const {
            containerWidth,
            containerHeight,
            zoomImageWidth,
            zoomImageHeight,
            widthDiff,
            heightDiff
        } = this.getBounds();

        const zoomImageLargeEnough = widthDiff > 0 || heightDiff > 0;
        this.setState({
            zoomImageLargeEnough
        });

        if (!zoomImageLargeEnough) {
            return;
        }

        const widthRatio = e.nativeEvent.offsetX / containerWidth;
        const heightRatio = e.nativeEvent.offsetY / containerHeight;

        const translateXValue =
            widthDiff > 0
                ? widthRatio * widthDiff
                : zoomImageWidth / 2 - containerWidth / 2;
        const translateYValue =
            heightDiff > 0
                ? heightRatio * heightDiff
                : zoomImageHeight / 2 - containerHeight / 2;

        const zoomImageElement = this.zoomImage.current;
        zoomImageElement.style.transform = `translate(${-translateXValue}px,
            ${-translateYValue}px)`;

        this.handleMouseHover(true);
    }

    getBounds() {
        if (this.bounds) {
            return this.bounds;
        }

        const zoomImageElement = this.zoomImage.current;
        const imageContainerElement = this.imageContainer.current;

        const {
            width: containerWidth,
            height: containerHeight
        } = imageContainerElement.getBoundingClientRect();
        const {
            width: zoomImageWidth,
            height: zoomImageHeight
        } = zoomImageElement.getBoundingClientRect();

        const widthDiff = zoomImageWidth - containerWidth;
        const heightDiff = zoomImageHeight - containerHeight;

        if (zoomImageWidth <= 0 || zoomImageHeight <= 0) {
            return {};
        }
        this.bounds = {
            containerWidth,
            containerHeight,
            zoomImageWidth,
            zoomImageHeight,
            widthDiff,
            heightDiff
        };

        return this.bounds;
    }

    render() {
        const { image, enableZoom, handleZoomClick } = this.props;
        const { hover, zoomImageLargeEnough } = this.state;
        const { alt, normal, smallFit, mediumFit, largeFit } = image;
        return (
            <div
                ref={this.imageContainer}
                className={`image-gallery-item ${
                    enableZoom ? 'cursor-zoom-in' : ''
                }`}>
                <MediaQuery minWidth={BREAKPOINT_SIZES[BREAKPOINTS.MD].min}>
                    <img
                        className={`d-inline-block image-gallery-item__image ${
                            !hover ? 'image-gallery-item__image--visible' : ''
                        }`}
                        src={largeFit}
                        srcSet={`${smallFit} 300w, ${mediumFit} 600w, ${largeFit} 900w`}
                        sizes="(max-width: 1024px) 560px, (max-width: 1249px) 809px, 611px"
                        alt={alt}
                    />
                    <img
                        ref={this.zoomImage}
                        loading="lazy"
                        className={`hover-img d-inline-block ${
                            hover && zoomImageLargeEnough
                                ? 'hover-img--visible'
                                : ''
                        }`}
                        src={
                            normal ||
                            '//static.tradera.net/internal/site/auction/noImage_344x258.gif'
                        }
                        alt={alt}
                    />
                </MediaQuery>
                <MediaQuery maxWidth={BREAKPOINT_SIZES[BREAKPOINTS.SM].max}>
                    <img
                        className="d-inline-block image-gallery-item__image image-gallery-item__image--visible"
                        src={largeFit}
                        srcSet={`${smallFit} 300w, ${mediumFit} 600w, ${largeFit} 900w`}
                        sizes="100vw"
                        alt={alt}
                    />
                </MediaQuery>
                <div
                    className="view-item--carousel__hitbox"
                    onClick={handleZoomClick}
                    onMouseMove={e => {
                        this.handleMouseMove(e);
                    }}
                    onMouseLeave={() => this.handleMouseHover(false)}
                />
            </div>
        );
    }
}

ViewItemImage.propTypes = {
    image: PropTypes.shape({
        alt: PropTypes.string.isRequired,
        normal: PropTypes.string.isRequired,
        medium: PropTypes.string.isRequired
    }).isRequired,
    enableZoom: PropTypes.bool,
    handleZoomClick: PropTypes.func
};

export default ViewItemImage;
